
export default class FlashMessagesStoreItem {
	_id;
	_messages;

	constructor({
		id,
		messages
	} = {}) {
		this._id = id;
		this._messages = messages;
	}

	get id() {
		return this._id;
	}

	set id(value) {
		this._id = value;
	}


	get messages() {
		return this._messages;
	}

	set messages(value) {
		this._messages = value;
	}
}
